export function initUrlControls() {
  document.getElementById("copy-url").addEventListener("click", () => {
    const urlField = document.getElementById("current-url");
    urlField.select();
    document.execCommand("copy");  // Copy the URL display contents to the clipboard
    urlField.blur(); // Deselect the text
  });
}

export function setSearchParams() {
  clearDrawParams();

  const query = document.getElementById("search-query").value;
  const match = document.getElementById("search-match").value;
  const filters = Array.from(document.querySelectorAll('#search-filters input[type="checkbox"]:checked')).map((checkbox) => checkbox.value);
  const popupCheckbox = document.getElementById("auto-popup-checkbox");

  const currentUrl = new URL(window.location);
  const queryParams = currentUrl.searchParams;

  query ? queryParams.set("q", query) : queryParams.delete("q");
  filters.length ? queryParams.set("filter", filters.join(",")) : queryParams.delete("filter");
  match ? queryParams.set("match", match) : queryParams.delete("match");
  queryParams.set("showpopup", popupCheckbox.checked.toString());

  window.history.pushState({ path: currentUrl.toString() }, "", currentUrl.toString());
  updateUrlDisplay();
}

// Clear the search settings parameters from the URL
export function clearSearchParams() {
  const currentUrl = new URL(window.location);
  const queryParams = currentUrl.searchParams;

  queryParams.delete("q");
  queryParams.delete("filter");
  queryParams.delete("match");
  queryParams.delete("showpopup");

  window.history.pushState({ path: currentUrl.toString() }, "", currentUrl.toString());
  updateUrlDisplay();
}

// Update the URL with the drawn geometries as WKT
export function setDrawParams(wkt) {
  clearSearchParams();

  const currentUrl = new URL(window.location);
  const queryParams = currentUrl.searchParams;

  queryParams.set("draw", wkt);
  // Remove the legacy single-drawing parameters
  queryParams.delete("drawType");
  queryParams.delete("drawCoords");

  window.history.pushState({ path: currentUrl.toString() }, "", currentUrl.toString());
  updateUrlDisplay();
}

// Clear the drawing parameters from the URL
export function clearDrawParams() {
  const currentUrl = new URL(window.location);
  const queryParams = currentUrl.searchParams;

  queryParams.delete("draw");
  queryParams.delete("drawType");
  queryParams.delete("drawCoords");

  window.history.pushState({ path: currentUrl.toString() }, "", currentUrl.toString());
  updateUrlDisplay();
}

// Clear all URL parameters
export function clearUrlParams() {
  clearSearchParams();
  clearDrawParams();
}

// Update the URL display with the current URL
export function updateUrlDisplay() {
  const url = new URL(window.location.href);
  url.searchParams.delete("showsidebar");
  document.getElementById("current-url").value = url.toString();
}